import { useState } from 'react';

import { useIsomorphicLayoutEffect } from '@lib/hooks'

import { useMarketStore } from './useMarketStore'

export const useMarketCoins = (coinCode) => {
  const marketStore = useMarketStore();
  const [marketCoins, setMarketCoins] = useState<any[]>([])
  const marketCoin = marketCoins.find(item => item.coinCode === coinCode);
  const getMarketCoin = async () => {
    const marketCoins = await marketStore.fetchMarketCoin();
    setMarketCoins(marketCoins);
  }

  useIsomorphicLayoutEffect(() => {
    if (marketStore.marketCoins?.length) {
      setMarketCoins(marketStore.marketCoins)
      return
    }
    getMarketCoin();
  }, [marketStore.marketCoins])
  return marketCoin || {};
}
